import { useState, useRef, useEffect } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import './Clients.css';
import { useNavigate } from 'react-router-dom';

gsap.registerPlugin(ScrollTrigger);

const clients = [
  {
    name: "USAID",
    logo: "./images/USAID.jpg",
    testimonial: "Transformed our regional offices with exceptional craftsmanship",
    highlightColor: "#C8102E",
    beforeImg: "https://images.unsplash.com/photo-1524758631624-e2822e304c36?w=500",
    ongoingImg: "https://images.unsplash.com/photo-1524758631624-e2822e304c36?w=500",
    afterImg: "./images/portfoliopictures/usaidwork.jpg"
  },
  {
    name: "APONYE",
    logo: "./images/aponye.jpg",
    testimonial: "Redefined luxury in our corporate headquarters",
    highlightColor: "#C8102E",
    beforeImg: "https://images.unsplash.com/photo-1524758631624-e2822e304c36?w=500",
    ongoingImg: "https://images.unsplash.com/photo-1524758631624-e2822e304c36?w=500",
    afterImg: "./images/portfoliopictures/aponye.jpg"
  },
  {
    name: "MUNYONYO MARTYRS SHRINE",
    logo: "./images/munyonyo1.jpg",
    testimonial: "Sacred spaces crafted with reverence and precision",
    highlightColor: "#C8102E",
    beforeImg: "https://images.unsplash.com/photo-1524758631624-e2822e304c36?w=500",
    ongoingImg: "https://images.unsplash.com/photo-1524758631624-e2822e304c36?w=500",
    afterImg: "images/portfoliopictures/munyonyo.jpg"
  },
  {
    name: "FINCA UGANDA",
    logo: "./images/portfoliopictures/finca2.jpg",
    testimonial: "Executive suites that impress our international partners",
    highlightColor: "#C8102E",
    beforeImg: "https://images.unsplash.com/photo-1524758631624-e2822e304c36?w=500",
    ongoingImg: "https://images.unsplash.com/photo-1524758631624-e2822e304c36?w=500",
    afterImg: "./images/portfoliopictures/finca2.jpg"
  },
  {
    name: "HISENSE",
    logo: "./images/hisense2.jpg",
    testimonial: "Showroom designs that elevated our brand experience",
    highlightColor: "#002F6C",
    beforeImg: "https://images.unsplash.com/photo-1524758631624-e2822e304c36?w=500",
    ongoingImg: "https://images.unsplash.com/photo-1524758631624-e2822e304c36?w=500",
    afterImg: "./images/portfoliopictures/hisensework.jpg"
  }
  ,
  {
    name: "OREON RESTUARANT",
    logo: "./images/portfoliopictures/oreonrestuarant.jpg",
    testimonial: "designs that elevated our brand experience",
    highlightColor: "#002F6C",
    beforeImg: "https://images.unsplash.com/photo-1524758631624-e2822e304c36?w=500",
    ongoingImg: "https://images.unsplash.com/photo-1524758631624-e2822e304c36?w=500",
    afterImg: "./images/portfoliopictures/oreonrestuarant.jpg"
  }
];

const Clients = () => {
  const [showModal, setShowModal] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);
  const sectionRef = useRef();
  const titleRef = useRef();
  const clientCardsRef = useRef([]);
  const nav =useNavigate()

  useEffect(() => {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: sectionRef.current,
        start: "top 70%",
        toggleActions: "play none none none"
      }
    });

    tl.from(titleRef.current, {
      y: 60,
      opacity: 0,
      duration: 1.2,
      ease: "power4.out"
    });

    tl.to(clientCardsRef.current, {
      y: 0,
      opacity: 1,
      stagger: 0.15,
      duration: 1,
      ease: "back.out(1.2)",
      delay: -0.8
    });

    clientCardsRef.current.forEach(card => {
      card.addEventListener("mouseenter", () => {
        gsap.to(card.querySelector(".client-logo"), {
          scale: 1.1,
          duration: 0.4
        });
      });
      card.addEventListener("mouseleave", () => {
        gsap.to(card.querySelector(".client-logo"), {
          scale: 1,
          duration: 0.4
        });
      });
    });
  }, []);

  const openModal = (client) => {
    setSelectedClient(client);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedClient(null);
  };

  return (
    <section className="clients-section" ref={sectionRef}>
      <div className="section-headerc">
        {/* <h5 style={{ color: 'maroon' }} ref={titleRef}>Trusted By <span style={{ color: 'maroon' }}>Visionaries</span></h5><br /><br /> */}
        <h2 onClick={()=>nav('/portfolio')} style={{color:"maroon",cursor:'pointer'}}>Our Happy Global Clients</h2>
      </div>

      <div className="client-showcase">
        {clients.slice(0, 4).map((client, index) => (
          <div
            key={index}
            className="client-card"
            ref={el => clientCardsRef.current[index] = el}
            style={{ '--highlight': client.highlightColor }}
            onClick={() => openModal(client)}
          >
            <div className="card-glass"></div>
            <div className="client-logo-container">
              <img src={client.logo} alt={client.name} className="client-logo" />
            </div>
            <div className="client-info">
              <h3>{client.name}</h3>
              <p>{client.testimonial}</p>
            </div>
            <div className="client-glow"></div>
          </div>
        ))}
      </div>

      {/* Modal */}
      {showModal && selectedClient && (
          <div className="modal-overlay" onClick={closeModal}>
            <div className="modal-content" onClick={e => e.stopPropagation()}>
              <span className="close-btn" onClick={closeModal}>&times;</span>
              <h2>{selectedClient.name}</h2>
              <p>{selectedClient.testimonial}</p>
              <div className="image-comparison">
                {/* Show only the completed work image */}
                <div>
                  <h4 style={{color:'maroon'}}>Completed Work</h4>
                  <img className="completed-work-img" src={selectedClient.afterImg} alt="Completed Work" />
                </div>
              </div>
            </div>
          </div>
        )}
    </section>
  );
};

export default Clients;
